import {
  type PSYCHIATRY_STEP_SLUG,
  type SKIP_SERVICE_STEP_SLUG,
} from '@/legacy-src/components/diagnosis/client/constants'

import type { DiagnosisSessionType } from '@/src/domains/diagnosis/constants'

export enum DiagnosisGuideSteps {
  name,
  serviceSelect,
  sessionType,
  sessionLocation,
  content1,
  topics,
  content2,
  test,
  content3,
  therapistPreferences,
  language,
  insurance,
  content4,
  time,
}

export type DiagnosisStepProps = {
  onChangeValues: () => void
}

export type PossibleStepSlugs = DiagnosisGuideSteps | typeof PSYCHIATRY_STEP_SLUG | typeof SKIP_SERVICE_STEP_SLUG

export enum SpecializationCategory {
  FEATURED = 0,
  PERSONAL_PROBLEMS = 1,
  PERSONAL_GROWTH = 2,
  FAMILY_AND_INTIMACY = 3,
  ADDICTIONS_AND_PERSONALITY_DISORDERS_AND_HEALTH = 4,
}

export type DiagnosisType = 'lead' | 'emotions' | 'past' | 'personality'

export type DiagnosisFields = {
  lead: number
  emotions: number
  past: number
  personality: number
  specialization: string[]
  sex: number
  service: number
  sessionType?: DiagnosisSessionType
  sessionLocation?: number[]
  therapyActivities: string[]
  language: string
}

export type DiagnosisFieldsPayload = Omit<
  DiagnosisFields,
  'specialization' | 'service' | 'therapyActivities' | 'sessionLocation' | 'sessionType'
> & {
  specialization: number[]
  therapyActivities: number[]
  services: number[]
  sessionType?: number | null
  sessionOfficeDistrictIds?: number[] | null
}

export type DiagnosisResponse = {
  diagnosis: DiagnosisFieldsPayload & {
    goal: number | null
    id: number
    userId: number
  }
  therapists: number[]
}

export type ExtendedDiagnosisFields = DiagnosisFields & {
  goal: number | null
  services: number[]
  id: number
  userId: number
  therapistAgeGroup: string
  maxPrice: string
  insuranceId: number
  partOfDay: number
  name?: string
}

export type ExtendedDiagnosisData = DiagnosisFieldsPayload & {
  goal: number | null
  services: number[]
  id: number
  userId: number
  therapistAgeGroup: number
  maxPrice: number
  insuranceId: number
  partOfDay: number
  name?: string
}

export type TherapistMatch = {
  therapistId: number
  ageGroup: number
  partsOfDay: number[]
  styleMatch: number
}

export type ExtendedDiagnosisResponse = {
  diagnosis: ExtendedDiagnosisData
  therapists: number[]
  therapistMatches: TherapistMatch[]
}

export type SpecializationType = {
  readonly name: string
  readonly id: number
  readonly category: number
}

export type SpecializationCheckboxType = {
  readonly value: string
  readonly label: string
  readonly category: number
}
